module.exports = __webpack_public_path__ + "img/workspace.e90764c5.svg";